import { useState } from "react";
import { getQuery } from "api/UdasWrapper";

const fetchTenantData = async (tenant_id) => {
  const query = JSON.stringify({
    query: `query Tenant($tenant_id: String!) {
      tenantbytenantid(tenant_id: $tenant_id) {
        tenant_id
        first_name
        last_name
        company_name
        logo_url
      }
    }`,
    variables: { tenant_id: `${tenant_id}` }
  });
  const response = await getQuery(query);
  const tenant = response.tenantbytenantid;

  return tenant;
};

export const useConnectorsWithCreator = () => {
  const [connectorsWithCreator, setConnectorsWithCreator] = useState([]);
  const [connectorCreators, setConnectorCreators] = useState({});

  const handleFetchConnectorsCreators = async (connectors) => {
    const connectorCreatorIds = Array.from(
      new Set(connectors?.map((connector) => connector.connector_creator_id) ?? [])
    );

    const handleGetTenants = async () => {
      const tenants = await Promise.all(
        connectorCreatorIds.map(async (creatorId) => {
          return await fetchTenantData(creatorId);
        })
      );

      const newConnectorsCreators = {};

      tenants.forEach((tenant) => {
        const creator = newConnectorsCreators[tenant?.tenant_id];

        if (!creator) {
          newConnectorsCreators[tenant.tenant_id] = {
            company_name: tenant.company_name,
            logo: tenant.logo_url
          };
        }
      });

      setConnectorCreators(newConnectorsCreators);
    };

    handleGetTenants();
  };

  const handleFetchConnectorsWithCreators = async (connectors) => {
    const updatedConnectorsWithCreator = connectors?.map((connector) => ({
      ...connector,
      connector_creator_id: connector.tenant_id
    }));

    setConnectorsWithCreator(updatedConnectorsWithCreator);

    await handleFetchConnectorsCreators(updatedConnectorsWithCreator);
  };

  return {
    connectorsWithCreator,
    connectorCreators,
    handleFetchConnectorsWithCreators
  };
};
